import { getAuth, onAuthStateChanged } from "firebase/auth";
import { authAxios } from '../utils/apiConfig';
import { logger } from '../utils/logger';

const imageAxios = authAxios;

function getCurrentUser() {
  return new Promise((resolve, reject) => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
}

export async function getBusinessImages(mapsUri = null) {
  try {
    const currentUser = await getCurrentUser();
    if (!currentUser) {
      throw new Error('No authenticated user');
    }

    const params = {
      user: currentUser.email
    };

    // Add maps_uri parameter if provided to filter images for specific business
    if (mapsUri) {
      params.maps_uri = mapsUri;
    }

    const response = await imageAxios.get('/images/', {
      params
    });

    return response.data;
  } catch (error) {
    logger.error("Error fetching business images: ", error);
    throw error;
  }
}

export async function getAllImages() {
  return getBusinessImages();
}

export async function getImagesByBusiness(mapsUri) {
  return getBusinessImages(mapsUri);
}

export default { getBusinessImages, getAllImages, getImagesByBusiness }; 